"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFiltersForField = exports.hasFilterForField = exports.hydrateLegacyFilter = exports.isLegacyTableFilter = exports.TableColumnFilterTypes = void 0;
var TableColumnFilterTypes;
(function (TableColumnFilterTypes) {
    TableColumnFilterTypes["Text"] = "text";
    TableColumnFilterTypes["MultiSelect"] = "multiSelect";
    TableColumnFilterTypes["Date"] = "date";
    TableColumnFilterTypes["Number"] = "number";
})(TableColumnFilterTypes || (exports.TableColumnFilterTypes = TableColumnFilterTypes = {}));
/** Type guard: returns true when the value is a legacy Record-based filter. */
const isLegacyTableFilter = (value) => {
    if (value == null || typeof value !== 'object')
        return false;
    return !('items' in value);
};
exports.isLegacyTableFilter = isLegacyTableFilter;
/** Converts a legacy Record-based filter to the multi-item TableFilter shape. */
const hydrateLegacyFilter = (legacy) => ({
    items: Object.entries(legacy).map(([field, filter]) => ({ field, filter })),
    logicOperator: 'and',
});
exports.hydrateLegacyFilter = hydrateLegacyFilter;
/** Checks whether a given field has any active filter items. */
const hasFilterForField = (tableFilter, field) => tableFilter.items.some((item) => item.field === field);
exports.hasFilterForField = hasFilterForField;
/** Returns all filter items for a given field. */
const getFiltersForField = (tableFilter, field) => tableFilter.items.filter((item) => item.field === field);
exports.getFiltersForField = getFiltersForField;
